import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface RecordAudio {
  isVoiceRecording: boolean;
}

const initialState: RecordAudio = {
  isVoiceRecording: false,
};

const recordAudioSlice = createSlice({
  name: "recordAudio",
  initialState,
  reducers: {
    setIsVoiceRecording(state, action: PayloadAction<boolean>) {
      state.isVoiceRecording = action.payload;
    },
  },
});

export const { setIsVoiceRecording } = recordAudioSlice.actions;

export default recordAudioSlice.reducer;
